import {
  getFavoriteActivities,
  removeFavoriteActivity,
  setSeanceFavorite,
  setTechniqueFavorite,
  setTutorialFavorite,
  setVisualSupportFavorite,
} from "domain/activities/activities.actions";
import { FavoriteActivity } from "domain/entities/activities.entities";
import { AppDispatch } from "domain/store";

interface IProps {
  favoriteActivity: FavoriteActivity;
  dispatch: AppDispatch;
  activityId: number;
  activityType: "seance" | "technique" | "tutorial" | "visual-support";
}

export async function toggleActivityFavorite({
  favoriteActivity,
  dispatch,
  activityId,
  activityType,
}: IProps) {
  if (!!favoriteActivity?.id) {
    const result = await dispatch(
      removeFavoriteActivity(favoriteActivity?.id)
    ).unwrap();
    if (result.success) {
      dispatch(getFavoriteActivities());
    }
  } else {
    if (activityType === "seance") {
      dispatch(setSeanceFavorite(activityId));
    } else if (activityType === "technique") {
      dispatch(setTechniqueFavorite(activityId));
    } else if (activityType === "tutorial") {
      dispatch(setTutorialFavorite(activityId));
    } else if (activityType === "visual-support") {
      dispatch(setVisualSupportFavorite(activityId));
    }
  }
}
